// extracted by mini-css-extract-plugin
module.exports = {"priceWithDiscount":"_1xnbHQ"};